import React, { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/context/AuthContext';
import LoadingScreen from '../components/LoadingScreen';

const ProtectedRoute = ({ allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  const isAuthorized = useMemo(() => {
    if (!user || !allowedRoles) return false;
    return allowedRoles.includes(user.role_id);
  }, [user, allowedRoles]);

  if (loading) {
    return <LoadingScreen/>; // Show a loading spinner or skeleton
  }

  if (!user) {
    console.log('No user found');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAuthorized) {
    console.log('Unauthorized');
    console.log('Allowed roles:', allowedRoles);
    console.log('User role:', user.role_id);

    return (
      <Navigate
        to="/unauthorized"
        state={{ userRole: user.role_id, allowedRoles, from: location }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;